import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { CommonModule } from '@angular/common';
import { PageHeaderComponent } from 'quest-atlas-angular-components';

@Component({
    selector: 'app-terms-of-use',
    standalone: true,
    imports: [CommonModule, PageHeaderComponent],
    templateUrl: './terms-of-use.component.html',
    styleUrls: ['./terms-of-use.component.scss']
})
export class TermsOfUseComponent {
  constructor(private router: Router) { }

  public navigateBack(): void {
    this.router.navigate(['']);
  }
}
